const assetsData = [
  {
    id: 1558,
    type: 'car',
    locationsHistory: [
      [36.75808, 3.45116],
      [36.75505, 3.46111],
      [36.75805, 3.46115],
      [36.75809, 3.43113],
      [36.75303, 3.48111],
    ],

    stats: [
      {
        name: 'Vehicule ID',
        value: '1558',
      },
      {
        name: 'Vehicule Type',
        value: 'Car',
      },
      {
        name: 'Engine',
        value: 'Running',
      },
      {
        name: 'Ambient Air Temp',
        value: '73.4 °F',
      },
      {
        name: 'Battery Voltage',
        value: '14.12V',
      },
    ],
  },
  {
    id: 4458,
    type: 'Truck',
    locationsHistory: [
      [36.75808, 3.45116],
      [36.75505, 3.46111],
      [36.75805, 3.46115],
      [36.75809, 3.43113],
      [36.75303, 3.48111],
    ],

    stats: [
      {
        name: 'Vehicule ID',
        value: '1558',
      },
      {
        name: 'Vehicule Type',
        value: 'Car',
      },
      {
        name: 'Engine',
        value: 'Running',
      },
      {
        name: 'Ambient Air Temp',
        value: '73.4 °F',
      },
      {
        name: 'Battery Voltage',
        value: '14.12V',
      },
    ],
  },
  {
    id: 3258,
    type: 'Bicyle',
    locationsHistory: [
      [36.75808, 3.45116],
      [36.75505, 3.46111],
      [36.75805, 3.46115],
      [36.75809, 3.43113],
      [36.75303, 3.48111],
    ],

    stats: [
      {
        name: 'Vehicule ID',
        value: '1558',
      },
      {
        name: 'Vehicule Type',
        value: 'Car',
      },
      {
        name: 'Engine',
        value: 'Running',
      },
      {
        name: 'Ambient Air Temp',
        value: '73.4 °F',
      },
      {
        name: 'Battery Voltage',
        value: '14.12V',
      },
    ],
  },
];

export default assetsData;
